import eventQueue from '../queue';
import { EventAction } from '../../types/events';
function attachEventListeners() {
    eventQueue.on('ui', function (_a) {
        var data = _a.data, fireAnalyticsEvent = _a.fireAnalyticsEvent;
        if (data.eventId === 'FullSwitchAndMore-entirePaycheck') {
            if (data.checked)
                return fireAnalyticsEvent(EventAction.FULL_SELECTED, {
                    ddAmountOverride: undefined,
                });
        }
    });
}
attachEventListeners();
